import React from 'react'

const FollowUp = (props) => {
    let { widgetsPreviewData: Data } = props;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;

    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }

    let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }
    return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='d-flex flex-column gap-2 observation-content w-100'>
            <p class="heading fs-13">Follow-Up</p>
            {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                noValExistText :
                <>
                    <div className="d-flex gap-1 text-nowrap">
                        <p className='heading'>Follow-Up Date:</p>
                        <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                    </div>
                    <div className="d-flex flex-column gap-6">
                        <p className='heading lh-12'>Notes:</p>
                        {isVisuallyEmpty(Data.FollowUpNotes) ?
                            noValExistText :
                            <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                    </div>
                </>
            }
        </div>
    </div>
    )
}

export default FollowUp